import { combineReducers } from "redux";

import list from '../reducers/listReducer';

export default combineReducers({
    list
});


// WEBPACK FOOTER //
// ./src/reducers/index.js